import { render, staticRenderFns } from "./wallet.vue?vue&type=template&id=e629bd78&"
import script from "./wallet.vue?vue&type=script&lang=ts&"
export * from "./wallet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports